import React, { useState, useEffect } from "react";
import { Container, Form, Button, Card, Alert, Row, Col } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { FaUserAlt, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { RiMailFill } from "react-icons/ri";
import { motion } from "framer-motion";

const MyProfile = () => {
    const { user, token, setUser } = useAuth();
    console.log("userrrrrrrrrrrrrrrrrrrrrrrrrrr",user)
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        address: {
            street: "",
            city: "",
            state: "",
            zip: "",
            country: ""
        },
        password: ""
    });
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setFormData({
                name: user.name || "",
                email: user.email || "",
                phone: user.phone || "",
                address: {
                    street: user.address?.street || "",
                    city: user.address?.city || "",
                    state: user.address?.state || "",
                    zip: user.address?.zip || "",
                    country: user.address?.country || ""
                },
                password: ""
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Check if the field is part of the address object
        if (name.includes('address.')) {
            const addressField = name.split('.')[1];
            setFormData(prev => ({
                ...prev,
                address: {
                    ...prev.address,
                    [addressField]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setMessage(null);
        setError(null);
        setIsLoading(true);

        try {
            console.log('[Profile] submitting update with token:', token);
            console.log('[Profile] payload:', formData);
            const response = await axios.put(
                "https://madhusewingmachines.com/api/user/update",
                formData,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            console.log('[Profile] response status:', response.status);
            console.log('[Profile] response data:', response.data);
            const updatedUser = response.data?.user;
            if (updatedUser) {
                // Update local form and global auth user/localStorage
                setFormData({
                    name: updatedUser.name || "",
                    email: updatedUser.email || "",
                    phone: updatedUser.phone || "",
                    address: {
                        street: updatedUser.address?.street || "",
                        city: updatedUser.address?.city || "",
                        state: updatedUser.address?.state || "",
                        zip: updatedUser.address?.zip || "",
                        country: updatedUser.address?.country || "",
                    },
                    password: "",
                });
                setUser(updatedUser);
                localStorage.setItem("user", JSON.stringify(updatedUser));
            }

            setMessage("Profile updated successfully!");
        } catch (err) {
            console.error('[Profile] update error:', err?.response?.data || err?.message);
            setError(err.response?.data?.message || "Profile update failed");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <Card className="shadow-lg p-4" style={{ maxWidth: "800px", width: "100%" }}>
                    <Card.Body>
                        <h3 className="text-center mb-4" style={{ color: "#25A1D5" }}>My Profile</h3>
                        {message && <Alert variant="success">{message}</Alert>}
                        {error && <Alert variant="danger">{error}</Alert>}

                        <Form onSubmit={handleUpdate}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><FaUserAlt /> Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            placeholder="Enter your name"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><RiMailFill /> Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            disabled
                                            placeholder="Your email"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label><FaPhoneAlt /> Phone Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            required
                                            placeholder="Enter your phone number"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <h5 className="mt-4 mb-3"><FaMapMarkerAlt /> Address</h5>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Street</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="address.street"
                                            value={formData.address.street}
                                            onChange={handleChange}
                                            required
                                            placeholder="Street address"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>City</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="address.city"
                                            value={formData.address.city}
                                            onChange={handleChange}
                                            required
                                            placeholder="City"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>State</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="address.state"
                                            value={formData.address.state}
                                            onChange={handleChange}
                                            required
                                            placeholder="State"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>ZIP Code</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="address.zip"
                                            value={formData.address.zip}
                                            onChange={handleChange}
                                            required
                                            placeholder="ZIP Code"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Country</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="address.country"
                                            value={formData.address.country}
                                            onChange={handleChange}
                                            required
                                            placeholder="Country"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="d-flex justify-content-end mt-3">
                                <Button type="submit" variant="primary" disabled={isLoading} style={{ backgroundColor: "#25A1D5", border: "none" }}>
                                    {isLoading ? "Saving..." : "Save Changes"}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </motion.div>
        </Container>
    );
};

export default MyProfile;
